/* ================================================================
   LIFULL — RSI Checkout Premium Enhancement
   Overrides inline !important styles, adds UI enhancements,
   builds a unified payment-method block (COD vs. prepay) next to
   the totals summary.
   ================================================================ */
(function () {
  'use strict';

  var BADGES = [
    { text: '✓ MÁS VENDIDO', cls: 'lco-offer-badge--popular' },
    { text: '★ MEJOR OFERTA', cls: 'lco-offer-badge--best'    },
    { text: '💰 MÁX. AHORRO', cls: 'lco-offer-badge--value'   },
  ];

  var TRUST = ['🔒 Pago Seguro', '🚚 Envío Rápido', '⭐ +10.000 clientes'];

  var SUBMIT_LABEL = '🚚 CONFIRMAR PEDIDO · PAGO CONTRA ENTREGA — ';
  var PAY_ADVANCE_LABEL = '🔥 AHORRA 5% ADICIONAL — PAGO ANTICIPADO';
  var PAY_METHOD_OPTIONS = [
    { key: 'cod', label: 'Pagar al recibir' },
    { key: 'prepay', label: 'Pagar ahora y ahorrar 5%' }
  ];

  /* setProperty with !important — overrides inline !important */
  function sp(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  /* ── 1. Header title ── */
  function styleHeader(form) {
    var title = form.querySelector('._rsi-modal-header-title');
    if (!title) return;
    sp(title, 'color', '#ffffff');
    sp(title, 'font-size', '0.76rem');
    sp(title, 'font-weight', '800');
    sp(title, 'letter-spacing', '0.09em');
    sp(title, 'text-transform', 'uppercase');
  }

  /* ── 2. Step custom-text blocks ── */
  function styleStepTexts(form) {
    form.querySelectorAll('._rsi-build-block-custom-text').forEach(function (block) {
      var inner = block.querySelector('._rsi-custom-text-field');
      if (!inner) return;
      var txt = inner.textContent || '';

      if (txt.indexOf('2️⃣') !== -1 || txt.indexOf('Escribe tus datos') !== -1) {
        block.style.display = 'none';
        return;
      }
      if (txt.indexOf('3️⃣') !== -1 || txt.indexOf('Confirma tu compra') !== -1) {
        block.style.display = 'none';
        return;
      }
      if (txt.indexOf('municipio') !== -1 || txt.indexOf('NO se despliega') !== -1) {
        block.style.padding = '0';
        block.style.margin = '0';
        sp(inner, 'color', '#92400e');
        sp(inner, 'font-size', '0.72rem');
        sp(inner, 'font-weight', '600');
        sp(inner, 'background', '#fffbeb');
        sp(inner, 'text-align', 'left');
        sp(inner, 'padding', '0.42rem 1.1rem');
        sp(inner, 'margin', '0');
        inner.className = (inner.className || '') + ' lco-warning-text';
      }
    });
  }

  /* ── 3. Offer card badges ──
     classList.add() reescribe el atributo class incluso si el token ya
     está presente (así lo define el propio DOM), y esta función corre
     desde el observer: sin el guard de contains(), cada llamada generaba
     una mutación de clase que volvía a disparar el observer — el mismo
     patrón de realimentación que el de las etiquetas de precio, pero acá. */
  function addBadges(form) {
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card, i) {
      if (!BADGES[i]) return;
      if (!card.querySelector('.lco-offer-badge')) {
        var badge = document.createElement('div');
        badge.className = 'lco-offer-badge ' + BADGES[i].cls;
        badge.textContent = BADGES[i].text;
        card.appendChild(badge);
      }
      if (!card.classList.contains('lco-has-offer-badge')) {
        card.classList.add('lco-has-offer-badge');
      }
    });
  }

  /* ── 4. Offer prices — make green (safety override) ── */
  function styleOfferPrices(form) {
    form.querySelectorAll('._rsi-quantity-offers-new-price').forEach(function (el) {
      sp(el, 'color', '#0E5F4A');
    });
  }

  /* ── 4b. Offer cards — una foto arriba + lista de radios ──
     Universal desde 12-septendecies: antes esto solo corría bajo
     matchMedia('(max-width:480px)') y escritorio se quedaba con las 3
     tarjetas grandes nativas de Releasit. El cliente no dio una
     referencia de escritorio -- la que dio era de mobile -- así que en
     vez de inventar un diseño nuevo sin referencia, el arquitecto
     decidió extender el mismo patrón ya aprobado a cualquier ancho.
     Releasit sigue poniendo el DOM (3 ._rsi-quantity-offers-offer-container
     con su imagen/título/precio/plaque); esto solo reorganiza esos
     nodos con CSS y moviéndolos de lugar, mismo patrón que ya usa el
     resto de esta función con el "plaque". El estado de selección no se
     inventa: se lee por CSS de _rsi-quantity-offers-selected, la clase
     real que Releasit ya pone en el contenedor al hacer clic (ver
     setupCheckmarks más abajo, mismo patrón).
     Al correr en cualquier ancho, ya no hay dos estados entre los que
     alternar (mobile con este diseño / escritorio con el nativo de
     Releasit) -- por eso resetOfferCardsMobileStyles() (12-quindecies/
     12-sexdecies) se eliminó: esa función solo existía para deshacer
     este bloque cuando el ancho cruzaba de vuelta al estado nativo, y
     ese estado nativo ya no existe en ningún ancho. */
  function styleOfferCards(form) {
    var mm = window.matchMedia;
    var isTiny = mm ? mm('(max-width: 360px)').matches : false;
    var isWide = mm ? mm('(min-width: 768px)').matches : false;
    var radioSize = isTiny ? '18px' : isWide ? '24px' : '20px';

    form.querySelectorAll('._rsi-quantity-offers').forEach(function (wrap) {
      sp(wrap, 'padding-inline', isTiny ? '0.6rem' : isWide ? '1.1rem' : '0.75rem');
      sp(wrap, 'gap', isWide ? '0.5rem' : '0.4rem');

      /* Una sola foto arriba de las 3 opciones: se MUEVE (no se clona)
         la imagen real de la primera oferta -- no se duplica el nodo ni
         se dispara una carga de red nueva. Las tres ofertas son el
         mismo producto, así que no hace falta una foto por fila. */
      var firstCard = wrap.querySelector('._rsi-quantity-offers-offer-container');
      var heroImg = firstCard && firstCard.querySelector('._rsi-modal-line-item-image-container');
      /* Ojo: heroImg da null en TODAS las pasadas después de la primera,
         porque la imagen ya se movió fuera de firstCard -- por eso el
         bloque de abajo (que también actualiza precio/nombre en cada
         cambio de oferta) no puede depender de "heroImg" para saber si
         correr, sino de si ya existe al menos una tarjeta (firstCard). */
      if (firstCard) {
        var heroWrap = form.querySelector('.lco-offer-hero-wrap');
        if (!heroWrap) {
          heroWrap = document.createElement('div');
          heroWrap.className = 'lco-offer-hero-wrap';
          wrap.parentNode.insertBefore(heroWrap, wrap);
        }
        if (heroImg && heroImg.parentNode !== heroWrap) heroWrap.appendChild(heroImg);

        /* Bloque de info a la derecha de la foto: nombre del producto +
           precio/ahorro de la oferta ELEGIDA (no siempre la de 1 unidad).
           Son nodos nuevos, no de Releasit -- el modal no expone el
           nombre del producto en ningún lado, así que sale de
           document.title (theme.liquid: "{{ page_title }} – {{ shop.name }}",
           confirmado en el navegador real, no asumido del código fuente). */
        var heroInfo = heroWrap.querySelector('.lco-offer-hero-info');
        if (!heroInfo) {
          heroInfo = document.createElement('div');
          heroInfo.className = 'lco-offer-hero-info';
          heroInfo.innerHTML =
            '<div class="lco-offer-hero-name"></div>' +
            '<div class="lco-offer-hero-price">' +
              '<span class="lco-offer-hero-price-new"></span>' +
              '<span class="lco-offer-hero-price-save"></span>' +
            '</div>';
          heroWrap.appendChild(heroInfo);
        }

        var heroName = heroInfo.querySelector('.lco-offer-hero-name');
        var rawTitle = document.title || '';
        /* Separador real "–" (en dash) confirmado en el navegador; no se
           usa un guion ASCII simple para no cortar nombres de producto
           que puedan traer uno propio. */
        var productName = rawTitle.split(/\s[–—]\s/)[0].trim() || rawTitle.trim();
        if (heroName && heroName.textContent !== productName) {
          heroName.textContent = productName;
        }

        /* Idempotente: esto corre desde el mismo observer/retry que el
           resto del archivo (sección 12-ter), así que solo se escribe si
           el texto cambió -- si no, la escritura misma retroalimenta el
           observer sin necesidad. */
        var selectedCard = wrap.querySelector('._rsi-quantity-offers-offer-container._rsi-quantity-offers-selected') || firstCard;
        var selPriceEl = selectedCard && selectedCard.querySelector('._rsi-quantity-offers-new-price');
        var selPlaques = selectedCard ? Array.prototype.slice.call(selectedCard.querySelectorAll('._rsi-quantity-offers-plaque, [class*="plaque"]')) : [];
        var selPlaque = selPlaques.find(function (el) {
          return /ahorra/i.test(el.textContent || '');
        });
        var newPriceText = selPriceEl ? selPriceEl.textContent.trim() : '';
        var saveText = selPlaque ? selPlaque.textContent.trim() : '';

        var heroPriceNew = heroInfo.querySelector('.lco-offer-hero-price-new');
        var heroPriceSave = heroInfo.querySelector('.lco-offer-hero-price-save');
        if (heroPriceNew && heroPriceNew.textContent !== newPriceText) {
          heroPriceNew.textContent = newPriceText;
        }
        if (heroPriceSave && heroPriceSave.textContent !== saveText) {
          heroPriceSave.textContent = saveText;
        }
      }
    });

    form.querySelectorAll('._rsi-quantity-offers-offer').forEach(function (offer) {
      sp(offer, 'display', 'grid');
      sp(offer, 'grid-template-columns', radioSize + ' minmax(0, 1fr) auto');
      sp(offer, 'grid-template-areas', '"radio title newprice" "radio badge oldprice"');
      sp(offer, 'column-gap', isTiny ? '0.5rem' : isWide ? '0.75rem' : '0.55rem');
      sp(offer, 'row-gap', '0.08rem');
      sp(offer, 'align-items', 'center');
      sp(offer, 'padding', isTiny ? '0.4rem 0.65rem' : isWide ? '0.6rem 0.9rem' : '0.42rem 0.7rem');

      /* [class*="plaque"] matea también a ._rsi-quantity-offers-plaque-container
         (su propio nombre de clase contiene la subcadena "plaque", y su
         textContent hereda el "ahorra..." de su hijo) -- sin excluirlo,
         .find() devuelve el contenedor (aparece antes en el orden del
         DOM, por ser el ancestro) en vez del plaque real, y el
         insertBefore de abajo termina moviendo el contenedor entero
         -- con el plaque real todavía anidado adentro -- a ser hijo
         directo de .offer, en vez de mover solo el plaque. Mismo
         criterio de exclusión agregado en 12-quindecies (commit
         905ee6a) para evitar un HierarchyRequestError. */
      var prices = offer.querySelector('._rsi-quantity-offers-prices');
      var plaques = Array.prototype.slice.call(offer.querySelectorAll('._rsi-quantity-offers-plaque, [class*="plaque"]'));
      var plaque = plaques.find(function (el) {
        return !el.classList.contains('_rsi-quantity-offers-plaque-container') && /ahorra/i.test(el.textContent || '');
      });
      if (plaque && plaque.parentNode !== offer) {
        offer.insertBefore(plaque, prices || null);
      }

      /* Punto de radio, mismo lenguaje visual que .lco-payment-radio
         (bloque de método de pago, f0e189a) para que las dos secciones
         del modal se vean consistentes entre sí. */
      if (!offer.querySelector('.lco-qty-radio')) {
        var radio = document.createElement('span');
        radio.className = 'lco-qty-radio';
        offer.insertBefore(radio, offer.firstChild);
      }
    });

    form.querySelectorAll('.lco-qty-radio').forEach(function (radio) {
      sp(radio, 'grid-area', 'radio');
      sp(radio, 'align-self', 'center');
      sp(radio, 'justify-self', 'start');
    });

    /* Sin imagen ni insignia de esquina por fila, ya no hace falta
       reservar aire extra arriba del título para no taparla. */
    form.querySelectorAll('._rsi-quantity-offers-offer ._rsi-modal-line-item-image-container').forEach(function (img) {
      sp(img, 'display', 'none');
    });

    form.querySelectorAll('._rsi-quantity-offers-info').forEach(function (info) {
      sp(info, 'grid-area', 'title');
      sp(info, 'width', '100%');
      sp(info, 'min-width', '0');
      sp(info, 'flex', 'initial');
    });

    /* Título con wrap normal (2 líneas si hace falta): Releasit repite el
       % de descuento dentro del propio título ("¡Compra 2 unidades con un
       15% de descuento +"), y con una sola línea + elipsis ese texto
       largo se cortaba a mitad de palabra (regresión reportada). Se deja
       que haga wrap en vez de recortarlo -- la fila crece en alto, pero
       radio/precio/badge siguen centrados verticalmente por su propio
       align-self, así que no se ve descuadrado. */
    form.querySelectorAll('._rsi-quantity-offers-title').forEach(function (title) {
      sp(title, 'font-size', isTiny ? '0.7rem' : isWide ? '0.86rem' : '0.74rem');
      sp(title, 'line-height', isWide ? '1.25' : '1.15');
      sp(title, 'margin-bottom', '0');
      sp(title, 'white-space', 'normal');
      sp(title, 'overflow', 'visible');
      sp(title, 'text-overflow', 'clip');
      sp(title, 'display', 'block');
      sp(title, 'max-width', '100%');
    });

    /* Misma exclusión que arriba: sin ella, este forEach también matea a
       ._rsi-quantity-offers-plaque-container (contiene la subcadena
       "plaque" y hereda el texto "ahorra..." de su hijo) y le aplica el
       mismo estilo de grid-item a los dos, uno anidado dentro del otro
       -- inocuo en la práctica (el hijo interno ignora su propio
       grid-area al no ser hijo directo del grid), pero es la misma
       fragilidad de selector que causó el HierarchyRequestError
       corregido en 12-quindecies (commit 905ee6a). */
    form.querySelectorAll('._rsi-quantity-offers-plaque, ._rsi-quantity-offers-offer [class*="plaque"]').forEach(function (plaque) {
      if (plaque.classList.contains('_rsi-quantity-offers-plaque-container')) return;
      if (!/ahorra/i.test(plaque.textContent || '')) return;
      sp(plaque, 'display', 'inline-flex');
      sp(plaque, 'grid-area', 'badge');
      sp(plaque, 'align-self', 'center');
      sp(plaque, 'width', 'fit-content');
      sp(plaque, 'max-width', '100%');
      sp(plaque, 'white-space', 'nowrap');
      sp(plaque, 'align-items', 'center');
      sp(plaque, 'justify-self', 'start');
      sp(plaque, 'position', 'static');
      sp(plaque, 'transform', 'none');
      sp(plaque, 'margin-left', '0');
      sp(plaque, 'left', 'auto');
      sp(plaque, 'right', 'auto');
      sp(plaque, 'top', 'auto');
      sp(plaque, 'bottom', 'auto');
      sp(plaque, 'line-height', '1.3');
      sp(plaque, 'padding-block', '0.08rem');
      sp(plaque, 'font-size', isTiny ? '0.5rem' : isWide ? '0.6rem' : '0.54rem');
      sp(plaque, 'padding-inline', isTiny ? '0.35rem' : isWide ? '0.5rem' : '0.4rem');
      /* Releasit trae margin-top propio pensado para la columna vertical
         original; en la fila compacta solo suma alto muerto. */
      sp(plaque, 'margin', '0');
    });

    /* Título + precio en la misma línea, ahorro + precio tachado en la
       línea de abajo (referencia del cliente) — dos líneas por fila en
       vez de tres. ._rsi-quantity-offers-prices agrupa el precio nuevo
       y el tachado en un solo nodo, pero acá van en renglones distintos;
       display:contents lo vuelve transparente para el grid y dejar que
       sus dos hijos se posicionen cada uno por su lado, sin tocar de
       qué nodo son hijos. */
    form.querySelectorAll('._rsi-quantity-offers-prices').forEach(function (prices) {
      sp(prices, 'display', 'contents');
    });

    form.querySelectorAll('._rsi-quantity-offers-new-price').forEach(function (price) {
      sp(price, 'grid-area', 'newprice');
      sp(price, 'align-self', 'center');
      sp(price, 'justify-self', 'end');
      sp(price, 'white-space', 'nowrap');
      sp(price, 'word-break', 'normal');
      sp(price, 'font-size', isTiny ? '0.86rem' : isWide ? '1.02rem' : '0.92rem');
      sp(price, 'margin', '0');
    });

    form.querySelectorAll('._rsi-quantity-offers-old-price').forEach(function (price) {
      sp(price, 'grid-area', 'oldprice');
      sp(price, 'align-self', 'center');
      sp(price, 'justify-self', 'end');
      sp(price, 'white-space', 'nowrap');
      sp(price, 'word-break', 'normal');
      sp(price, 'font-size', isTiny ? '0.62rem' : isWide ? '0.72rem' : '0.66rem');
      /* Releasit trae margin-bottom propio (pensaba en precio tachado
         arriba del nuevo, apilados); en la fila horizontal solo agranda
         el carril del grid sin motivo. */
      sp(price, 'margin', '0');
    });
  }

  function setupOfferCardsMobileObserver(form) {
    if (form.dataset.lcoMobileOfferObserver === 'true') return;
    form.dataset.lcoMobileOfferObserver = 'true';

    var raf = null;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        styleOfferCards(form);
        addBadges(form);
        styleSubmitBtn(form);
        stylePayAdvanceBtn(form);
        buildUnifiedPaymentBlock(form);
      });
    }

    var observer = new MutationObserver(schedule);
    observer.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    window.addEventListener('resize', schedule, { passive: true });

    var attempts = 0;
    var retry = setInterval(function () {
      styleOfferCards(form);
      addBadges(form);
      styleSubmitBtn(form);
      stylePayAdvanceBtn(form);
      buildUnifiedPaymentBlock(form);
      attempts += 1;
      if (attempts >= 16) clearInterval(retry);
    }, 250);

    /* Releasit crea un formulario nuevo en cada apertura (confirmado: no
       reutiliza el nodo), así que sin esto cada apertura deja para
       siempre un listener de resize y un observer corriendo sobre un
       formulario ya desconectado del DOM. Se libera cuando el formulario
       se elimina (ver el observer de documento más abajo). */
    registerCleanup(form, function () {
      observer.disconnect();
      window.removeEventListener('resize', schedule);
      clearInterval(retry);
      if (raf) cancelAnimationFrame(raf);
    });
  }

  /* ── 5. Main submit button ── */
  function styleSubmitBtn(form) {
    var btn = form.querySelector('._rsi-modal-submit-button');
    if (!btn) return;
    sp(btn, 'background', 'linear-gradient(135deg, #d49000 0%, #FBDB12 45%, #f5c842 100%)');
    sp(btn, 'color', '#1a0800');
    sp(btn, 'border-radius', '14px');
    sp(btn, 'box-shadow', '0 4px 28px rgba(251,219,18,0.58), 0 2px 8px rgba(0,0,0,0.22)');
    sp(btn, 'font-size', '0.94rem');

    /* Rewrite label text, preserving the dynamic price span.
       Solo se reescribe si hace falta: esta funcion corre desde un
       MutationObserver, y escribir la misma etiqueta igual cuenta como
       mutacion, lo que realimentaria el observer indefinidamente. */
    var outerSpan = btn.querySelector('span');
    if (!outerSpan) return;
    var priceEl = outerSpan.querySelector('.rsi-cod-form-submit-total-value');
    if (!priceEl) return;
    if (outerSpan.childNodes.length === 2 && outerSpan.firstChild.nodeValue === SUBMIT_LABEL) return;
    outerSpan.textContent = '';
    outerSpan.appendChild(document.createTextNode(SUBMIT_LABEL));
    outerSpan.appendChild(priceEl);
  }

  /* Base del 5%: el nodo "subtotal" de Releasit trae el precio de lista, sin el
     descuento por cantidad, que viaja en una línea aparte. Hay que restarlo, o el
     precio mostrado no coincide con el cobrado. El total del botón de envío no
     sirve como fuente porque incluye el envío, pero sí como validación cruzada.
     El importe se redondea hacia arriba a propósito: no sabemos en qué dirección
     redondea Shopify el medio peso final, y así el cliente nunca paga más de lo
     que vio. */
  function parseCopAmount(text) {
    if (!text) return null;
    var cleaned = ('' + text).replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    var lastComma = cleaned.lastIndexOf(',');
    var integerPart, decimalPart;
    if (lastComma === -1) {
      integerPart = cleaned;
      decimalPart = '0';
    } else {
      integerPart = cleaned.slice(0, lastComma);
      decimalPart = cleaned.slice(lastComma + 1);
    }
    integerPart = integerPart.split('.').join('');
    if (!/^\d+$/.test(integerPart) || !/^\d{1,2}$/.test(decimalPart)) return null;
    if (decimalPart.length === 1) decimalPart += '0';
    var value = parseInt(integerPart, 10) + parseInt(decimalPart, 10) / 100;
    return isFinite(value) ? value : null;
  }

  function formatCop(value) {
    var withThousands = String(Math.ceil(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + withThousands + ',00';
  }

  function getPayAdvancePriceLabel(form) {
    var subtotalEl = form.querySelector(
      '._rsi-modal-checkout-line[data-checkout-line="subtotal"] ._rsi-modal-checkout-line-value'
    );
    if (!subtotalEl) return null;
    var subtotal = parseCopAmount(subtotalEl.textContent);
    if (subtotal === null) return null;

    var discountEl = form.querySelector(
      '._rsi-modal-checkout-line[data-checkout-line="discount"] ._rsi-modal-checkout-line-value'
    );
    var discount = 0;
    if (discountEl) {
      var parsedDiscount = parseCopAmount(discountEl.textContent);
      if (parsedDiscount === null) return null; /* hay línea de descuento pero no se pudo leer: no adivinar */
      discount = parsedDiscount;
    }
    var base = subtotal - discount;

    /* Validación cruzada contra el total de contraentrega (mismo importe
       pre-prepago, sin envío). Si no coincide, la fórmula ya no describe
       lo que se está cobrando y es más seguro no mostrar nada. */
    var codTotalEl = form.querySelector('.rsi-cod-form-submit-total-value');
    if (codTotalEl) {
      var codTotal = parseCopAmount(codTotalEl.textContent);
      if (codTotal === null || Math.round(codTotal) !== Math.round(base)) return null;
    }

    return formatCop(base * 0.95);
  }

  /* Escribe la etiqueta de pago anticipado en cualquier nodo de texto,
     solo si el valor cambia. Ambos botones (el original de Releasit y el
     reubicado junto a totales) comparten esta misma fuente de precio, así
     que no pueden divergir. Idempotente por la regla de la sección
     12-ter: escribir el mismo textContent desde un MutationObserver
     también cuenta como mutación y realimenta el observer. */
  function applyPayAdvancePriceLabel(el, baseLabel, form) {
    if (!el) return;
    var priceLabel = getPayAdvancePriceLabel(form);
    var label = priceLabel ? baseLabel + ' — ' + priceLabel : baseLabel;
    if (el.textContent !== label) el.textContent = label;
  }

  /* ── 6. Pay-advance button (original, bottom position) ── */
  function stylePayAdvanceBtn(form) {
    var btn = form.querySelector('._rsi-buy-now-custom-additionals-button');
    if (!btn) return;
    sp(btn, 'background', 'linear-gradient(135deg, #4c1d95 0%, #6d28d9 50%, #7c3aed 100%)');
    sp(btn, 'color', '#ffffff');
    sp(btn, 'border', '0px solid transparent');
    sp(btn, 'border-radius', '12px');
    sp(btn, 'box-shadow', '0 4px 18px rgba(109,40,217,0.42)');
    sp(btn, 'font-size', '0.85rem');
    sp(btn, 'font-weight', '800');

    var span = btn.querySelector('span');
    if (!span) return;
    applyPayAdvancePriceLabel(span, PAY_ADVANCE_LABEL, form);
  }

  /* ── 7. Bloque unificado de método de pago (12-sexies) ──
     Antes: dos botones sueltos y funcionales (contraentrega al final del
     formulario, pago anticipado duplicado junto a totales y original al
     final) compitiendo en dos sitios de la pantalla. Esto los reemplaza
     por una sola elección con ambos precios visibles: dos filas junto a
     totales para elegir, y un único CTA donde antes estaba el botón de
     contraentrega.

     Regla que no se negocia: esto nunca reimplementa el envío del
     pedido. Releasit resuelve la compra con un listener propio atado a
     SU botón (._rsi-modal-submit-button / ._rsi-buy-now-custom-additionals-button,
     no navegable por href ni por atributos, ver P0-2). Este bloque solo
     decide cuál de los dos originales recibe el .click() delegado en el
     momento en que el cliente confirma. Los originales quedan ocultos
     (display:none) pero intactos en el DOM — nunca se destruyen, nunca
     se les copia el estado.

     Defensivo por diseño: si falta cualquier pieza necesaria (algún
     botón real, el total de contraentrega, o si el precio de pago
     anticipado no se puede verificar — misma regla de "nunca mostrar un
     precio que no se pueda comprobar"), el bloque se retira si ya
     existía y los dos originales de Releasit vuelven a quedar visibles
     y funcionando, tal como estaban antes de que existiera esta función.
     Preferible que no aparezca a que aparezca roto o a medias. */
  function buildUnifiedPaymentBlock(form) {
    var totalsBlock = form.querySelector('._rsi-modal-checkout-lines');
    var codBtn = form.querySelector('._rsi-modal-submit-button');
    var prepayBtn = form.querySelector('._rsi-buy-now-custom-additionals-button');
    var codPriceEl = form.querySelector('.rsi-cod-form-submit-total-value');
    var codSubmitBlock = form.querySelector('._rsi-build-block-submit-button');
    var prepayBlock = form.querySelector('._rsi-build-block-custom-button-checkout');

    var choiceWrap = form.querySelector('.lco-payment-choice-wrap');
    var ctaWrap = form.querySelector('.lco-unified-submit-wrap');

    var codPriceText = codPriceEl ? (codPriceEl.textContent || '').trim() : '';
    var prepayPriceLabel = getPayAdvancePriceLabel(form);

    var ready = !!(totalsBlock && codBtn && prepayBtn && codPriceEl && codSubmitBlock &&
      prepayBlock && codPriceText && prepayPriceLabel);

    if (!ready) {
      if (choiceWrap) choiceWrap.remove();
      if (ctaWrap) ctaWrap.remove();
      if (codSubmitBlock) sp(codSubmitBlock, 'display', '');
      if (prepayBlock) sp(prepayBlock, 'display', '');
      var staleOverride = totalsBlock ? totalsBlock.querySelector('.lco-total-override') : null;
      if (staleOverride) staleOverride.remove();
      var staleTotalValueEl = totalsBlock ? totalsBlock.querySelector('[data-checkout-line="total"] ._rsi-modal-checkout-line-value:not(.lco-total-override)') : null;
      if (staleTotalValueEl) sp(staleTotalValueEl, 'display', '');
      return;
    }

    /* ── Elección: dos filas tipo radio, junto a totales ── */
    if (!choiceWrap) {
      choiceWrap = document.createElement('div');
      choiceWrap.className = 'lco-payment-choice-wrap';

      PAY_METHOD_OPTIONS.forEach(function (def) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'lco-payment-option';
        opt.dataset.paymentOption = def.key;
        opt.innerHTML =
          '<span class="lco-payment-radio"></span>' +
          '<span class="lco-payment-option-label">' + def.label + '</span>' +
          '<span class="lco-payment-option-price"></span>';
        opt.addEventListener('click', function () {
          if (form.dataset.lcoPaymentChoice !== def.key) {
            form.dataset.lcoPaymentChoice = def.key;
            buildUnifiedPaymentBlock(form);
          }
        });
        choiceWrap.appendChild(opt);
      });
    }

    if (!form.dataset.lcoPaymentChoice) form.dataset.lcoPaymentChoice = 'cod';
    var choice = form.dataset.lcoPaymentChoice;

    setPaymentOption(choiceWrap, 'cod', codPriceText, choice === 'cod');
    setPaymentOption(choiceWrap, 'prepay', prepayPriceLabel, choice === 'prepay');

    /* El "Total" de arriba refleja la opción de pago elegida -- pedido
       explícito del arquitecto tras ver el resultado, no un bug: antes
       se quedaba siempre en el total de contraentrega aunque el cliente
       hubiera elegido pagar por anticipado. Reusa los mismos dos valores
       que ya se calculan arriba (codPriceText/prepayPriceLabel) y que ya
       están verificados para la fila elegida y el CTA -- no se recalcula
       nada nuevo, así los tres lugares nunca pueden desincronizarse entre
       sí.
       NUNCA se escribe el texto del nodo real: se probó primero (con
       nuestro JS completamente desactivado, para descartar cualquier
       cosa nuestra) y Releasit sincroniza lo que sea que se escriba ahí
       hacia _rsi-modal-submit-button's texto real de cobro
       (.rsi-cod-form-submit-total-value) -- escribir "$1.234,00" de
       prueba en el Total terminó apareciendo también en el botón real
       de pago contraentrega. Corrompe el total real de Releasit, no solo
       la pantalla. Se usa el mismo patrón "ocultar, no destruir" que ya
       usa el resto de esta función con los botones originales: el nodo
       real de Releasit se oculta con display:none (nunca se le toca el
       texto) y se inserta un nodo nuevo, propio, al lado, con el precio
       correspondiente -- confirmado con la misma prueba que ocultar sin
       tocar texto no corrompe nada. */
    var totalValueEl = totalsBlock.querySelector('[data-checkout-line="total"] ._rsi-modal-checkout-line-value');
    if (totalValueEl) {
      sp(totalValueEl, 'display', 'none');
      var totalOverride = totalValueEl.nextElementSibling;
      if (!totalOverride || !totalOverride.classList.contains('lco-total-override')) {
        totalOverride = document.createElement('div');
        totalOverride.className = totalValueEl.className + ' lco-total-override';
        totalValueEl.parentNode.insertBefore(totalOverride, totalValueEl.nextSibling);
      }
      var totalText = choice === 'prepay' ? prepayPriceLabel : codPriceText;
      if (totalOverride.textContent !== totalText) totalOverride.textContent = totalText;
    }

    if (choiceWrap.previousElementSibling !== totalsBlock) {
      totalsBlock.parentNode.insertBefore(choiceWrap, totalsBlock.nextSibling);
    }

    /* ── CTA único, en el lugar donde vivía el botón de contraentrega ── */
    if (!ctaWrap) {
      ctaWrap = document.createElement('div');
      ctaWrap.className = 'lco-unified-submit-wrap';
      var ctaBtn = document.createElement('button');
      ctaBtn.type = 'button';
      ctaBtn.className = 'lco-unified-submit-btn';
      ctaBtn.addEventListener('click', function () {
        var currentChoice = form.dataset.lcoPaymentChoice || 'cod';
        var target = currentChoice === 'prepay'
          ? form.querySelector('._rsi-buy-now-custom-additionals-button')
          : form.querySelector('._rsi-modal-submit-button');
        if (target) target.click();
      });
      ctaWrap.appendChild(ctaBtn);
    }

    var ctaBtnEl = ctaWrap.querySelector('.lco-unified-submit-btn');
    var ctaLabel = choice === 'prepay'
      ? (PAY_ADVANCE_LABEL + ' — ' + prepayPriceLabel)
      : (SUBMIT_LABEL + codPriceText);
    if (ctaBtnEl.textContent !== ctaLabel) ctaBtnEl.textContent = ctaLabel;

    var wantsPrepayStyle = choice === 'prepay';
    var hasPrepayStyle = ctaBtnEl.classList.contains('lco-unified-submit-btn--prepay');
    if (wantsPrepayStyle && !hasPrepayStyle) ctaBtnEl.classList.add('lco-unified-submit-btn--prepay');
    else if (!wantsPrepayStyle && hasPrepayStyle) ctaBtnEl.classList.remove('lco-unified-submit-btn--prepay');

    if (ctaWrap.nextElementSibling !== codSubmitBlock) {
      codSubmitBlock.parentNode.insertBefore(ctaWrap, codSubmitBlock);
    }

    /* Ocultar, no destruir: siguen siendo los que de verdad procesan el
       pedido; el CTA de arriba solo les delega el clic. */
    sp(codSubmitBlock, 'display', 'none');
    sp(prepayBlock, 'display', 'none');
  }

  function setPaymentOption(choiceWrap, key, priceText, isSelected) {
    var optionEl = choiceWrap.querySelector('[data-payment-option="' + key + '"]');
    if (!optionEl) return;
    var priceSpan = optionEl.querySelector('.lco-payment-option-price');
    if (priceSpan && priceSpan.textContent !== priceText) priceSpan.textContent = priceText;

    var hasSelected = optionEl.classList.contains('lco-payment-option--selected');
    if (isSelected && !hasSelected) optionEl.classList.add('lco-payment-option--selected');
    else if (!isSelected && hasSelected) optionEl.classList.remove('lco-payment-option--selected');
  }

  /* ── 8. Trust bar (bottom of form) ── */
  function addTrustBar(form) {
    if (form.querySelector('.lco-trust-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'lco-trust-bar';
    TRUST.forEach(function (text) {
      var item = document.createElement('span');
      item.className = 'lco-trust-item';
      item.textContent = text;
      bar.appendChild(item);
    });
    form.appendChild(bar);
  }

  /* ── 9. Step headers (2 + 3) ── */
  function insertStepHeaders(form) {
    insertStepHeader(form, '2', 'TUS DATOS DE ENTREGA', function (f) {
      return f.querySelector('._rsi-modal-fields-item');
    });
    insertStepHeader(form, '3', 'CONFIRMA TU COMPRA', function (f) {
      return f.querySelector('#rsi-cod-form-tick-ups-hook') ||
             f.querySelector('._rsi-build-block-submit-button');
    });
  }

  function insertStepHeader(form, num, label, findTarget) {
    var target = findTarget(form);
    if (!target) return;
    var prev = target.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('lco-step-header')) return;

    var divider = document.createElement('div');
    divider.className = 'lco-step-divider';

    var header = document.createElement('div');
    header.className = 'lco-step-header';

    var numEl = document.createElement('div');
    numEl.className = 'lco-step-num';
    numEl.textContent = num;

    var labelEl = document.createElement('div');
    labelEl.className = 'lco-step-label';
    labelEl.textContent = label;

    header.appendChild(numEl);
    header.appendChild(labelEl);

    target.parentNode.insertBefore(divider, target);
    target.parentNode.insertBefore(header, divider);
  }

  /* ═══════════════════════════════════════════
     CONVERSION ANIMATIONS — injected elements
     ═══════════════════════════════════════════ */

  /* ── Urgency bar ── */
  function addUrgencyBar(form) {
    if (form.querySelector('.lco-urgency-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'lco-urgency-bar';
    bar.innerHTML =
      '<span class="lco-urgency-dot"></span>' +
      '⚡ OFERTA ESPECIAL — PRECIOS EXCLUSIVOS HOY' +
      '<span class="lco-urgency-dot"></span>';
    var header = form.querySelector('._rsi-modal-header');
    if (header) header.parentNode.insertBefore(bar, header.nextSibling);
  }

  /* ── Selection checkmark on product image ── */
  function setupCheckmarks(form) {
    function update() {
      form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
        var imgWrap = card.querySelector('._rsi-quantity-offers-offer ._rsi-modal-line-item-image-container');
        if (!imgWrap) return;
        imgWrap.style.position = 'relative';
        var existing = imgWrap.querySelector('.lco-offer-check');
        if (card.classList.contains('_rsi-quantity-offers-selected')) {
          if (!existing) {
            var ck = document.createElement('div');
            ck.className = 'lco-offer-check';
            ck.textContent = '✓';
            imgWrap.appendChild(ck);
          }
        } else {
          if (existing) existing.remove();
        }
      });
    }
    update();
    var observers = [];
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
      var obs = new MutationObserver(update);
      obs.observe(card, { attributes: true, attributeFilter: ['class'] });
      observers.push(obs);
    });
    registerCleanup(form, function () {
      observers.forEach(function (obs) { obs.disconnect(); });
    });
  }

  /* ── Bouncing arrow above submit button ── */
  function addCtaArrow(form) {
    if (form.querySelector('.lco-cta-arrow')) return;
    var submitBlock = form.querySelector('._rsi-build-block-submit-button');
    if (!submitBlock) return;
    var arrow = document.createElement('div');
    arrow.className = 'lco-cta-arrow';
    arrow.textContent = '↓';
    submitBlock.parentNode.insertBefore(arrow, submitBlock);
  }

  /* ── Main enhancement entry point ── */
  function enhance(form) {
    watchForClose(form);

    /* First pass: styles + structure */
    setTimeout(function () {
      styleHeader(form);
      styleStepTexts(form);
      styleOfferPrices(form);
      styleOfferCards(form);
      setupOfferCardsMobileObserver(form);
      styleSubmitBtn(form);
      stylePayAdvanceBtn(form);

      /* Conversion animations — top zone */
      addUrgencyBar(form);

      /* Bloque unificado de método de pago, junto a totales */
      buildUnifiedPaymentBlock(form);

      /* Offer card enhancements */
      addBadges(form);
      setupCheckmarks(form);

      /* Form zone */
      insertStepHeaders(form);
      addCtaArrow(form);

      /* Footer */
      addTrustBar(form);
    }, 120);

    /* Second pass at 680ms — safety retry */
    setTimeout(function () {
      styleSubmitBtn(form);
      stylePayAdvanceBtn(form);
      styleOfferCards(form);
      buildUnifiedPaymentBlock(form);
      addBadges(form);
      setupCheckmarks(form);
      addCtaArrow(form);
    }, 680);
  }

  /* ── Cleanup registry (P2-2) ──
     Releasit crea un formulario nuevo en cada apertura del modal —
     verificado: nunca reutiliza el nodo anterior — así que todo listener,
     observer o intervalo atado a un `form` debe liberarse cuando ESE
     formulario se elimina del DOM, o queda corriendo para siempre sobre
     un nodo desconectado. */
  var cleanups = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function registerCleanup(form, fn) {
    if (!cleanups) return;
    var list = cleanups.get(form);
    if (!list) { list = []; cleanups.set(form, list); }
    list.push(fn);
  }

  function runCleanup(form) {
    if (!cleanups) return;
    var list = cleanups.get(form);
    if (!list) return;
    cleanups.delete(form);
    list.forEach(function (fn) {
      try { fn(); } catch (e) { /* una falla no debe frenar el resto de la limpieza */ }
    });
  }

  function findModalFormIn(node) {
    if (!node || node.nodeType !== 1) return null;
    if (node.classList && node.classList.contains('_rsi-modal-form')) return node;
    return node.querySelector ? node.querySelector('._rsi-modal-form') : null;
  }

  /* Al cerrar el modal, Releasit NO quita ni oculta el <form> — dos
     niveles arriba, el contenedor pierde la clase
     `_rsi-cod-form-modal-open`. El formulario en sí solo se destruye
     cuando se abre el modal DE NUEVO (verificado). Sin este observer, la
     limpieza de registerCleanup solo llegaría en la próxima apertura, y
     el último cierre de una sesión (lo más común) quedaría sin limpiar
     nunca. */
  function watchForClose(form) {
    if (form.dataset.lcoCloseWatcher === 'true') return;
    form.dataset.lcoCloseWatcher = 'true';

    var openWrapper = form.closest && form.closest('._rsi-cod-form-modal-open');
    if (!openWrapper) return; /* estructura inesperada: se apoya solo en la limpieza por eliminación del nodo */

    var closeObserver = new MutationObserver(function () {
      if (!openWrapper.classList.contains('_rsi-cod-form-modal-open')) {
        closeObserver.disconnect();
        runCleanup(form);
      }
    });
    closeObserver.observe(openWrapper, { attributes: true, attributeFilter: ['class'] });

    registerCleanup(form, function () { closeObserver.disconnect(); });
  }

  /* ── MutationObserver — detects RSI modal injection/removal ── */
  var seen = typeof WeakSet !== 'undefined' ? new WeakSet() : [];

  function wasSeen(el) {
    return typeof WeakSet !== 'undefined' ? seen.has(el) : seen.indexOf(el) !== -1;
  }
  function markSeen(el) {
    if (typeof WeakSet !== 'undefined') seen.add(el);
    else seen.push(el);
  }

  function checkNode(node) {
    if (!node || node.nodeType !== 1) return;
    var form = node.classList && node.classList.contains('_rsi-modal-form')
      ? node
      : node.querySelector && node.querySelector('._rsi-modal-form');
    if (form && !wasSeen(form)) { markSeen(form); enhance(form); }
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(checkNode);
      m.removedNodes.forEach(function (node) {
        var form = findModalFormIn(node);
        if (form) runCleanup(form);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* In case modal is already in the DOM */
  var existing = document.querySelector('._rsi-modal-form');
  if (existing && !wasSeen(existing)) { markSeen(existing); enhance(existing); }

})();
